var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGovernanceAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0234 12.9062H13.9766V22.9531H24.0234V12.9062Z",
    stroke: "#333333",
    strokeWidth: 1.85481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.209 30.4883C12.2812 30.4883 13.9766 28.7929 13.9766 26.7207V22.9531H10.209C8.13682 22.9531 6.44141 24.6485 6.44141 26.7207C6.44141 28.7929 8.13682 30.4883 10.209 30.4883Z",
    stroke: "#333333",
    strokeWidth: 1.85481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.209 12.9102H13.9766V9.14258C13.9766 7.07041 12.2812 5.375 10.209 5.375C8.13682 5.375 6.44141 7.07041 6.44141 9.14258C6.44141 11.2147 8.13682 12.9102 10.209 12.9102Z",
    stroke: "#333333",
    strokeWidth: 1.85481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0234 12.9102H27.791C29.8632 12.9102 31.5586 11.2147 31.5586 9.14258C31.5586 7.07041 29.8632 5.375 27.791 5.375C25.7188 5.375 24.0234 7.07041 24.0234 9.14258V12.9102Z",
    stroke: "#333333",
    strokeWidth: 1.85481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.791 30.4883C29.8632 30.4883 31.5586 28.7929 31.5586 26.7207C31.5586 24.6485 29.8632 22.9531 27.791 22.9531H24.0234V26.7207C24.0234 28.7929 25.7188 30.4883 27.791 30.4883Z",
    stroke: "#333333",
    strokeWidth: 1.85481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernanceAi);
export default __webpack_public_path__ + "static/media/GovernanceAI.7c7a36fdec072940334a8427423fd26e.svg";
export { ForwardRef as ReactComponent };